import { statistics } from './statistics';

export const average = {
  statistics,
};
